import React, { useState, useEffect } from 'react';
import { Link, Routes, Route, useNavigate } from 'react-router-dom';
import AdminCategoriesPage from './AdminCategoriesPage';
import AdminProductsPage from './AdminProductsPage';
import './AdminPage.css';

const ADMIN_API_URL = "https://ewpfvffejfybyxcgnhim2bwwyi0gybco.lambda-url.eu-west-2.on.aws";

export default function AdminPage({ userData }) {
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Перевіряємо наявність токена
    if (!userData?.token) {
      navigate('/');
      return;
    }

    // Спрощена перевірка авторизації
    setIsAuthorized(true);
    setIsLoading(false);
  }, [userData, navigate]);

  if (isLoading) {
    return <div className="admin-loading">Loading...</div>;
  }

  if (!isAuthorized) {
    return null; // Буде перенаправлено на головну через useEffect
  }

  return (
    <div className="admin-page">
      <div className="admin-sidebar">
        <div className="admin-logo">
          <h2>Selezium Admin</h2>
        </div>
        <nav className="admin-nav">
          <ul>
            <li>
              <Link to="/admin/categories" className="admin-nav-link">
                <i className="fas fa-tags"></i> Categories
              </Link>
            </li>
            <li>
              <Link to="/admin/products" className="admin-nav-link">
                <i className="fas fa-box"></i> Products
              </Link>
            </li>
            <li>
              <Link to="/admin/orders" className="admin-nav-link">
                <i className="fas fa-shopping-cart"></i> Orders
              </Link>
            </li>
          </ul>
        </nav>
      </div>
      <div className="admin-content">
        <Routes>
          <Route path="/categories" element={<AdminCategoriesPage userData={userData} />} />
          <Route path="/products" element={<AdminProductsPage userData={userData} />} />
          <Route path="/" element={<AdminCategoriesPage userData={userData} />} />
          <Route path="*" element={<AdminCategoriesPage userData={userData} />} />
        </Routes>
      </div>
    </div>
  );
} 